<script>
	//Services
	import { gen2Request } from '../../../../services/gen_2_http_reqs';
	import { format } from 'svelte-i18n';

	//Stores
		import { getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	//Helpers
	import { onSettingsResponse } from '../../../../helpers/device_settings_helpers';
	import { real_id } from '../../../../helpers/interface_helpers';

	//Design system components
	import { Button, Slider, Text } from '@Shelly/shelly-design-system';
	import { capFirstChar } from 'src/helpers/utilities';
	import { getContext, onDestroy } from 'svelte';

	export let device;

	const id = real_id(device.id);
	$: settingsStore = getDeviceSettings(id);
	$: settings = $settingsStore;

	let idleBrightness = settings?.ui?.idle_brightness;
	let cacheBrightness = idleBrightness,
		loading = false;

	const brightnessChange = (e) => {
		idleBrightness = e.detail.value;
	};

	const sendRequest = async () => {
		if (cacheBrightness !== idleBrightness) {
			loading = true;
			const method = 'ui.setconfig';
			const params = {
				config: { idle_brightness: idleBrightness },
			};
			const res = await gen2Request(device, method, params);
			const response = onSettingsResponse(res, device);
			if (response) {
				settings.ui.idle_brightness = idleBrightness;
				devices_settings.update_devices_settings(id, settings);
			} else {
				idleBrightness = cacheBrightness;
			}
			loading = false;

			cacheBrightness = idleBrightness;
		}
	};

	const a11yProps = {
		sliderValueText: $format('current_brightness_value', {
			values: { value: idleBrightness },
			default: `Current brightness value is ${idleBrightness}`,
		}),
		ariaLabel: $format('label_set_brightness', { default: 'Set Brightness' }),
		ariaLabelValue: $format('current_brightness_value', {
			values: { value: idleBrightness },
			default: `Current brightness value is ${idleBrightness}`,
		}),
	};

	const stickyBottomAction = getContext('stickyBottomAction');

	$: if (stickyBottomAction) {
		if ($showNewLayout) {
			stickyBottomAction.set({ onClick: sendRequest, loading, disabled: loading });
		} else {
			stickyBottomAction.set(null);
		}
	}

	onDestroy(() => {
		stickyBottomAction?.set(null);
	});
</script>

<Text class="mb-s"
	>{$format('display_mode_desc', {
		default: 'Select idle display brightness',
	})}</Text
>
<Slider
	id="slider-tb4nvrv"
	{a11yProps}
	type="horizontal"
	value={idleBrightness}
	title={capFirstChar($format('collapse_title_brightness'))}
	on:value_change={brightnessChange}
/>
{#if !$showNewLayout}
	<Button class="mt-s" {loading} size="m" width="full" on:click={sendRequest}
		>{$format('button_save')}</Button
	>
{/if}
